import cn from '@sindresorhus/class-names';
import {PropsWithChildren} from 'react';

import styles from './Layout.module.scss';
import {AsideMenu, RightSidebarAd} from './parts';

type Props = PropsWithChildren<{
  className?: string;
  hasSidemenu?: boolean;
  isFullwidth?: boolean;
  jsonLd?: string;
  allowRightSidebarAd?: boolean;
}>;

export const Layout = ({
  className,
  hasSidemenu,
  isFullwidth,
  jsonLd,
  allowRightSidebarAd,
  children,
}: Props) => (
  <div className={cn(styles.layout, className)}>
    {jsonLd && (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{__html: jsonLd}}
      />
    )}
    <main
      className={cn(styles.main, {
        [styles.fullWidth]: isFullwidth,
      })}
    >
      {hasSidemenu && <AsideMenu />}

      {children}
    </main>
    {allowRightSidebarAd && <RightSidebarAd className={styles.adPlaceholder} />}
  </div>
);
